<template>
  <div id="app">
    <keep-alive>
      <!--使用keep-alive会将页面缓存-->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import { getCookie } from './assets/js/tool'
export default {
  name: "App",
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    ...mapMutations({
      senduserInfo: "SENDuserInfo",
      sendagentText:"SENDagentText",
      senddirectorText:"SENDdirectorText"
    }),
    async configAjax() {
      let response = await this.$commonPost({
        jydm: "flow_10060",
        flow_10060: {}
      });
      let arr = [];
      if (response.resp_code == "0" && response.resp_result == "0") {
        if (response.config) {
          if (response.config.length > 0) {
            arr = response.config;
          } else {
            arr.push(response.config);
          }
        }
        arr.map(item => {
          localStorage.setItem(`otherConfig_${item.nbr}`, item.value);
          if(item.nbr=='10033') sessionStorage.setItem(`otherConfig_${item.nbr}`, item.value);
        });

        this.sendagentText('店主');
        this.senddirectorText('经理');
      } else {
        let arr = [
          "10000",
          "10001",
          "10002",
          "10003",
          "10004",
          "10005",
          "10006",
          "10007",
          "10008",
          "10009",
          "10010",
          "10011"
        ];
        arr.map(item => {
          localStorage.setItem(`otherConfig_${item}`, 0);
          this.sendagentText(localStorage.getItem('otherConfig_10008')==2?'店长':'掌柜');
          this.senddirectorText(localStorage.getItem('otherConfig_10008')==2?'联合创始人':'董事');
        });
      }
    },
  },
  created() {
    let that =this
    this.configAjax();
  },
  mounted() {
  }
};
</script>

<style>
#app {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/App.vue